import { EntityDescriptor, EntityEditorPage, EntityEditorPageProps } from "@crispico/foundation-react";
import { TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";

export class VacKeyEntityDescriptor extends EntityDescriptor {

    constructor() {
        super({ name: "VacKey", miniFields: ["value"] });
    }

    protected customize() {
        this.infoEditor.wrappedComponentClass = class extends EntityEditorPage<EntityEditorPageProps> {
            protected getExtraTabPanes(): (TabRouterPane | null)[] {
                return [
                    ...super.getExtraTabPanes(),
                    {
                        ...this.createOneToManyTabPane("VacKey_directEquipmentResources__EquipmentResource_directVacKeys", "vacKey"),
                        menuItemProps: { content: _msg("VacKey.equipmentResourceTab.label"), icon: entityDescriptors["EquipmentResource"].icon }
                    },
                    {
                        ...this.createOneToManyTabPane("VacKey_vacKeyGroups__VacKeyGroup_vacKeys", "vacKey", {}),
                        menuItemProps: { content: entityDescriptors["VacKeyGroup"].getLabel(true), icon: entityDescriptors["VacKeyGroup"].icon }
                    }
                ];
            }
        }
    }
}
